export default {
    motion: "#4C97FF",
    looks: "#9966FF",
    sounds: "#CF63CF",
    control: "#FFAB19",
    event: "#FFBF00",
    sensing: "#5CB1D6",
    operators: "#59C059",
    data: "#FF8C1A",
    data_lists: "#FF661A",
    more: "#FF6680",
}